// extracted by mini-css-extract-plugin
export var collapsedSummary = "_pt-0";